import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import { ZIndex } from '../../../styles/constants';

export const View = styled.div`
  background-color: ${ThemeColours.white};
  bottom: 0;
  box-shadow: 4px 2px 10px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  left: 0;
  overflow-y: auto;
  position: fixed;
  top: 0;
  width: 320px;
  z-index: ${ZIndex.OVERLAY};

  &.exit {
    left: 0;
  }

  &.exit-active {
    left: -320px;
    transition: left 0.3s ease-in;
  }

  &.enter {
    left: -320px;
  }

  &.enter-active {
    left: 0;
    transition: left 0.3s ease-out;
  }
`;
